(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@braindate/util/lib/assert"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@braindate/util/lib/assert"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.assert);
    global.membershipAssertions = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _assert) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.assertMembership = assertMembership;
  _exports.assertMembershipFlags = assertMembershipFlags;
  _exports.assertMembershipPreferences = assertMembershipPreferences;
  _exports.assertMembershipURLs = assertMembershipURLs;
  /**
   * Throw an exception if parameter is not an object
   * @param   {any} value - Value to check
   * @returns {undefined}
   */
  function assertMembership(value) {
    (0, _assert.assertObject)(value, "membership");
  }

  /**
   * Throw an exception if parameter is not an object
   * @param   {any} value - Value to check
   * @returns {undefined}
   */
  function assertMembershipFlags(value) {
    (0, _assert.assertObject)(value, "membership.flags");
  }

  /**
   * Throw an exception if parameter is not an object
   * @param   {any} value - Value to check
   * @returns {undefined}
   */
  function assertMembershipPreferences(value) {
    (0, _assert.assertObject)(value, "membership.preferences");
  }

  /**
   * Throw an exception if parameter is not an object
   * @param   {any} value - Value to check
   * @returns {undefined}
   */
  function assertMembershipURLs(value) {
    (0, _assert.assertObject)(value, "membership.urls");
  }
});